var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "config-container" }, [
    _c(
      "div",
      {
        staticClass: "row flex-container",
        class: [_vm.readonly === true ? "readOnly" : "normalMode"],
      },
      [
        _vm.alerts.sos
          ? _c("h2", { staticClass: "card-category col-12" }, [
              _vm._v(_vm._s(_vm.$t("profile.alerts.heading"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.alerts, function (tag, key) {
          return _c(
            "CardAlert",
            {
              key: key,
              class: {
                disabled: !_vm.hasUserValidOffer(tag),
                "licence-offer-difference": !_vm.hasUserValidOffer(tag),
              },
              attrs: {
                alertKey: key,
                alerts: tag.alert,
                readonly: _vm.readonly,
              },
              on: {
                change: function ($event) {
                  return _vm.modification("config")
                },
              },
            },
            [
              _c(
                "span",
                { attrs: { slot: "title" }, slot: "title" },
                [
                  _vm._v(
                    "\n                  " +
                      _vm._s(tag.description) +
                      "\n                  "
                  ),
                  _vm.$te("profile.helpers." + key)
                    ? _c("UiInfoTooltip", {
                        attrs: { content: _vm.$t("profile.helpers." + key) },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("i", {
                class: _vm.icons[key],
                attrs: { slot: "icon" },
                slot: "icon",
              }),
              _vm._v(" "),
              _vm._l(tag, function (tagChild, keyChild) {
                return [
                  tagChild.type == "boolean"
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isUnusedItem(tagChild),
                              expression: "!isUnusedItem(tagChild)",
                            },
                          ],
                          staticClass: "button-switch",
                          class: {
                            "licence-offer-difference":
                              !_vm.hasUserValidOffer(tagChild),
                          },
                          attrs: {
                            title: _vm.getTooltipForCard(
                              tagChild,
                              key,
                              keyChild
                            ),
                          },
                        },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "switcher",
                              attrs: {
                                checked: tagChild.value == 1 ? true : false,
                                disabled: !_vm.hasUserValidOffer(tagChild),
                                value: "1",
                                "unchecked-value": "0",
                                switch: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.modification("config")
                                },
                              },
                              model: {
                                value: tagChild.value,
                                callback: function ($$v) {
                                  _vm.$set(tagChild, "value", $$v)
                                },
                                expression: "tagChild.value",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm._v(
                                    "\n                              " +
                                      _vm._s(tagChild.description) +
                                      "\n                              "
                                  ),
                                  _vm.$te(
                                    "profile.helpers." + key + "-" + keyChild
                                  )
                                    ? _c("UiInfoTooltip", {
                                        attrs: {
                                          content: _vm.$t(
                                            "profile.helpers." +
                                              key +
                                              "-" +
                                              keyChild
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  tagChild.type == "list"
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isUnusedItem(tagChild),
                              expression: "!isUnusedItem(tagChild)",
                            },
                          ],
                          staticClass: "form-row",
                          class: {
                            "licence-offer-difference":
                              !_vm.hasUserValidOffer(tagChild),
                          },
                          attrs: {
                            title: _vm.getTooltipForCard(
                              tagChild,
                              key,
                              keyChild
                            ),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("label", [
                                _vm._v(_vm._s(tagChild.description)),
                              ]),
                              _vm._v(" "),
                              _vm.$te("profile.helpers." + key + "-" + keyChild)
                                ? _c("UiInfoTooltip", {
                                    attrs: {
                                      content: _vm.$t(
                                        "profile.helpers." +
                                          key +
                                          "-" +
                                          keyChild
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: tagChild.value,
                                  expression: "tagChild.value",
                                },
                              ],
                              staticClass: "form-input col",
                              attrs: {
                                disabled: !_vm.hasUserValidOffer(tagChild),
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      tagChild,
                                      "value",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function ($event) {
                                    return _vm.modification("config")
                                  },
                                ],
                              },
                            },
                            _vm._l(tagChild.values, function (val, keyVal) {
                              return _c(
                                "option",
                                { domProps: { value: keyVal } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(val) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  tagChild.type == "number"
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isUnusedItem(tagChild),
                              expression: "!isUnusedItem(tagChild)",
                            },
                          ],
                          staticClass: "with-complex-range press-time-select",
                          class: {
                            "licence-offer-difference":
                              !_vm.hasUserValidOffer(tagChild),
                          },
                          attrs: {
                            title: _vm.getTooltipForCard(
                              tagChild,
                              key,
                              keyChild
                            ),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "label",
                                { staticClass: "tagchild-description" },
                                [_vm._v(_vm._s(tagChild.description))]
                              ),
                              _vm._v(" "),
                              _vm.$te("profile.helpers." + key + "-" + keyChild)
                                ? _c("UiInfoTooltip", {
                                    attrs: {
                                      content: _vm.$t(
                                        "profile.helpers." +
                                          key +
                                          "-" +
                                          keyChild
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center gap-3" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center gap-1",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: tagChild.value,
                                        expression: "tagChild.value",
                                      },
                                    ],
                                    staticClass: "value value-input-time-press",
                                    attrs: {
                                      readonly: _vm.readonly,
                                      type: "text",
                                      disabled:
                                        !_vm.hasUserValidOffer(tagChild),
                                    },
                                    domProps: { value: tagChild.value },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.handleBlurNumberField(
                                          tagChild,
                                          tagChild.values.min,
                                          tagChild.values.max,
                                          tagChild.values.step
                                        )
                                      },
                                      change: function ($event) {
                                        return _vm.modification("config")
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          tagChild,
                                          "value",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "unit" }, [
                                    _vm._v(
                                      "\n                                  " +
                                        _vm._s(tagChild.unit) +
                                        "\n                          "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  tagChild.unit == "m" && tagChild.value >= 60
                                    ? _c("span", { staticClass: "converted" }, [
                                        _vm._v(
                                          "\n                                  (" +
                                            _vm._s(
                                              _vm.convertInHour(tagChild.value)
                                            ) +
                                            ")\n                          "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  tagChild.unit == "s" && tagChild.value >= 60
                                    ? _c("span", { staticClass: "converted" }, [
                                        _vm._v(
                                          "\n                                  (" +
                                            _vm._s(
                                              _vm.convertInMin(tagChild.value)
                                            ) +
                                            ")\n                          "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: tagChild.value,
                                    expression: "tagChild.value",
                                  },
                                ],
                                staticClass: "form-input",
                                class: {
                                  "over-threshold":
                                    tagChild.values.threshold &&
                                    (tagChild.value >
                                      tagChild.values.threshold.max.value ||
                                      tagChild.value <
                                        tagChild.values.threshold.min.value),
                                },
                                attrs: {
                                  disabled: !_vm.hasUserValidOffer(tagChild),
                                  max: tagChild.values.max,
                                  min: tagChild.values.min,
                                  step: tagChild.values.step,
                                  type: "range",
                                },
                                domProps: { value: tagChild.value },
                                on: {
                                  change: function ($event) {
                                    return _vm.modification("config")
                                  },
                                  __r: function ($event) {
                                    return _vm.$set(
                                      tagChild,
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          tagChild.values.threshold &&
                          (tagChild.value >
                            tagChild.values.threshold.max.value ||
                            tagChild.value <
                              tagChild.values.threshold.min.value)
                            ? _c(
                                "div",
                                { staticClass: "over-threshold-text" },
                                [
                                  tagChild.value >
                                  tagChild.values.threshold.max.value
                                    ? [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              tagChild.values.threshold.max.text
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  tagChild.value <
                                  tagChild.values.threshold.min.value
                                    ? [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              tagChild.values.threshold.min.text
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          tagChild.values.sensitivity_level
                            ? _c(
                                "div",
                                { staticClass: "fall-sensitivity-level" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getFallSensitivityLevel(
                                        tagChild.value,
                                        tagChild.values.sensitivity_level
                                      )
                                    ) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _vm.$te("profile.helpers." + key + "-footer")
                ? _c("div", {
                    staticClass: "mt-3 text-gray-500",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("profile.helpers." + key + "-footer")
                      ),
                    },
                  })
                : _vm._e(),
            ],
            2
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row flex-container" },
      [
        _c("h2", { staticClass: "card-category" }, [
          _vm._v(_vm._s(_vm.$t("profile.sound_effect.heading"))),
        ]),
        _vm._v(" "),
        _vm.soundAlertEffectConfig &&
        Object.keys(_vm.soundEffectConfig).length !== 0
          ? _c("CardAlertSoundEffect", {
              attrs: {
                sounds: _vm.soundAlertEffectConfig,
                readonly: _vm.readonly,
              },
              on: {
                change: function ($event) {
                  return _vm.modification("config")
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.soundEffectConfig && Object.keys(_vm.soundEffectConfig).length !== 0
          ? _c("CardSoundEffect", {
              attrs: { sounds: _vm.soundEffectConfig, readonly: _vm.readonly },
              on: {
                change: function ($event) {
                  return _vm.modification("config")
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row flex-container" },
      [
        _vm._l(_vm.configCategories, function (categoryItems, categoryKey) {
          return [
            categoryItems.length > 0
              ? _c("h2", { key: categoryKey, staticClass: "card-category" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t(_vm.categoriesLabel[categoryKey])) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(categoryItems, function (categoryItem, index) {
              return _c(
                "CardSimple",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isUnusedItem(categoryItem),
                      expression: "!isUnusedItem(categoryItem)",
                    },
                  ],
                  key: categoryKey + "-" + index,
                  class: {
                    "licence-offer-difference":
                      !_vm.hasUserValidOffer(categoryItem),
                    disabled: !_vm.hasUserValidOffer(categoryItem),
                  },
                  attrs: {
                    title: _vm.getTooltipForCard(
                      categoryItem,
                      categoryItem.key
                    ),
                  },
                },
                [
                  categoryItem.key === "level_visibility"
                    ? _c("IconWatchmanVisibility", {
                        attrs: { slot: "icon" },
                        slot: "icon",
                      })
                    : _c("i", {
                        class: _vm.icons[categoryItem.key],
                        attrs: { slot: "icon" },
                        slot: "icon",
                      }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(categoryItem.description) +
                        "\n                  "
                    ),
                  ]),
                  _vm._v(" "),
                  categoryItem.type == "boolean"
                    ? _c("UiSwitch", {
                        attrs: { "true-value": 1, "false-value": 0 },
                        model: {
                          value: categoryItem.value,
                          callback: function ($$v) {
                            _vm.$set(categoryItem, "value", $$v)
                          },
                          expression: "categoryItem.value",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  categoryItem.type == "number"
                    ? _c(
                        "div",
                        { staticClass: "form-row with-complex-range" },
                        [
                          _c("span", { staticClass: "value" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: categoryItem.value,
                                  expression: "categoryItem.value",
                                },
                              ],
                              staticClass: "value",
                              attrs: { readonly: _vm.readonly, type: "text" },
                              domProps: { value: categoryItem.value },
                              on: {
                                blur: function ($event) {
                                  return _vm.handleBlurNumberField(
                                    categoryItem,
                                    categoryItem.values.min,
                                    categoryItem.values.max,
                                    categoryItem.values.step
                                  )
                                },
                                change: function ($event) {
                                  return _vm.modification("config")
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    categoryItem,
                                    "value",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(
                                _vm._s(categoryItem.unit) +
                                  "\n                          "
                              ),
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            categoryItem.unit == "s" && categoryItem.value >= 60
                              ? _c(
                                  "span",
                                  { staticClass: "value-conversion" },
                                  [
                                    _vm._v(
                                      "\n                            (" +
                                        _vm._s(
                                          _vm.convertInMin(categoryItem.value)
                                        ) +
                                        ")\n                          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            categoryItem.unit == "m" && categoryItem.value >= 60
                              ? _c(
                                  "span",
                                  { staticClass: "value-conversion" },
                                  [
                                    _vm._v(
                                      "\n                              (" +
                                        _vm._s(
                                          _vm.convertInHour(categoryItem.value)
                                        ) +
                                        ")\n                          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: categoryItem.value,
                                expression: "categoryItem.value",
                              },
                            ],
                            staticClass: "form-input",
                            class: {
                              "over-threshold":
                                categoryItem.values.threshold &&
                                (categoryItem.value >
                                  categoryItem.values.threshold.max.value ||
                                  categoryItem.value <
                                    categoryItem.values.threshold.min.value),
                            },
                            attrs: {
                              disabled: _vm.readonly,
                              max: categoryItem.values.max,
                              min: categoryItem.values.min,
                              step: categoryItem.values.step,
                              type: "range",
                            },
                            domProps: { value: categoryItem.value },
                            on: {
                              change: function ($event) {
                                return _vm.modification("config")
                              },
                              __r: function ($event) {
                                return _vm.$set(
                                  categoryItem,
                                  "value",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          categoryItem.values.threshold &&
                          (categoryItem.value >
                            categoryItem.values.threshold.max.value ||
                            categoryItem.value <
                              categoryItem.values.threshold.min.value)
                            ? _c(
                                "div",
                                { staticClass: "over-threshold-text" },
                                [
                                  categoryItem.value >
                                  categoryItem.values.threshold.max.value
                                    ? [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              categoryItem.values.threshold.max
                                                .text
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  categoryItem.value <
                                  categoryItem.values.threshold.min.value
                                    ? [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              categoryItem.values.threshold.min
                                                .text
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  categoryItem.type == "list"
                    ? _c("div", { staticClass: "form-row" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: categoryItem.value,
                                expression: "categoryItem.value",
                              },
                            ],
                            staticClass: "form-input col",
                            attrs: { disabled: _vm.readonly },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    categoryItem,
                                    "value",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function ($event) {
                                  return _vm.modification("config")
                                },
                              ],
                            },
                          },
                          _vm._l(categoryItem.values, function (val, keyVal) {
                            return _c(
                              "option",
                              { key: keyVal, domProps: { value: keyVal } },
                              [_vm._v(_vm._s(val) + "\n            ")]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  categoryItem.type == "relation"
                    ? _c("div", { staticClass: "form-row" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: categoryItem.value,
                                expression: "categoryItem.value",
                              },
                            ],
                            staticClass: "form-input col",
                            attrs: { disabled: _vm.readonly },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    categoryItem,
                                    "value",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function ($event) {
                                  return _vm.modification(
                                    "config",
                                    categoryItem.key
                                  )
                                },
                              ],
                            },
                          },
                          [
                            _c("option"),
                            _vm._v(" "),
                            _vm._l(categoryItem.values, function (val, keyVal) {
                              return _c(
                                "option",
                                { key: keyVal, domProps: { value: val.id } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.constructLabelByKey(
                                        categoryItem.key,
                                        val
                                      )
                                    ) + "\n            "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "more-infos-inner",
                      attrs: { slot: "moreInfos" },
                      slot: "moreInfos",
                    },
                    [
                      _c("div", { staticClass: "license" }, [
                        categoryItem.offers.includes("45")
                          ? _c("span", {
                              staticClass: "licence-type-45",
                              domProps: {
                                innerHTML: _vm._s(_vm.pictoStandard),
                              },
                            })
                          : categoryItem.offers.includes("43")
                          ? _c("span", {
                              staticClass: "licence-type-43",
                              domProps: { innerHTML: _vm._s(_vm.pictoPremium) },
                            })
                          : categoryItem.offers.includes("35")
                          ? _c("span", {
                              staticClass: "licence-type-35",
                              domProps: { innerHTML: _vm._s(_vm.pictoPremium) },
                            })
                          : categoryItem.offers.includes("58")
                          ? _c("span", {
                              staticClass: "licence-type-58",
                              domProps: {
                                innerHTML: _vm._s(_vm.pictoEnterprise),
                              },
                            })
                          : categoryItem.offers.includes("57")
                          ? _c("span", { staticClass: "licence-type-57" }, [
                              _c("i", { staticClass: "fa fa-upload" }),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "os" }, [
                        _c("i", {
                          staticClass: "fa fa-android",
                          class: {
                            disabled: categoryItem.compatible_android == 0,
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-apple",
                          class: { disabled: categoryItem.compatible_ios == 0 },
                        }),
                      ]),
                    ]
                  ),
                ],
                1
              )
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }